import * as R from 'ramda';
import { Endpoints } from '../../../../core/api/endpoints';
import { ApiReducer, makeApiReducer, makeApiAction, makeRsaaTypes } from '../../../../core/api/rsaa';
import { addError, noLoadingNoError, addLoading, getLoading } from '../../../../core/api/module';
import { ActionType } from '../../../../core/redux/actionType';
import { DevPlanFieldAndAnswer } from '../../models';
import { actionFieldsById } from '../module';


const KEY_ACTION = ActionType.GetDevPlanFieldsAndAnswersRequest;
const ACTIONS    = [
  ActionType.GetDevPlanFieldsAndAnswersRequest,
  ActionType.GetDevPlanFieldsAndAnswersResponse,
  ActionType.GetDevPlanFieldsAndAnswersError,
];


type Payload = DevPlanFieldAndAnswer[];

type Meta = {
  projectId: number;
  participantId: number;
};


/**
 * Dispatch this action to get the list of dev plan action fields and answers
 */
export const getDevPlanFieldsAndAnswersAction = (
  projectId: number,
  participantId: number,
) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.GetDevPlanFieldsAndAnswers,
  headers:  { 'content-type': 'application/json' },
  body:     state => JSON.stringify({ projectId, participantId, languageId: state.locale.lang.languageId }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { projectId, participantId }),
  bailout:  state => !!getLoading(state, KEY_ACTION),
});


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  const actions = (payload || [])
    .map(fa => !!fa.devPlanFieldId ? fa : R.assoc('devPlanFieldId', fa.question, fa));

  return R.assocPath(['devPlan', 'fieldsAnswers'], actionFieldsById(actions), successState);
};


export const getDevPlanFieldsAndAnswersReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
